<mat-form-field [appearance]="appearance" class="searchable-dropdown-field">
  <mat-label *ngIf="labelText">{{ labelText }}</mat-label>

  <input
    matInput
    type="text"
    autocomplete="off"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    [required]="isRequired"
    [placeholder]="placeholder"
    [errorStateMatcher]="matcher"
    (input)="onSearchInput($event)"
    (blur)="onBlur()"
  />

  <mat-icon
    matSuffix
    class="muted searchable-dropdown-clear"
    *ngIf="showClear && !isDisabled && hasText"
    (click)="clear($event)"
    >close</mat-icon
  >
  <mat-icon matSuffix class="muted" *ngIf="showSearchIcon">search</mat-icon>

  <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="label"
    (optionSelected)="onOptionSelected($event.option.value)"
    (opened)="onPanelOpened()"
    (closed)="onPanelClosed()"
  >
    <mat-option *ngIf="loading" disabled>Loading…</mat-option>

    <ng-container *ngIf="filteredOptions$ | async as filtered">
      <ng-container *ngIf="!loading">
        <mat-option
          *ngFor="let option of filtered; trackBy: trackByOption"
          [value]="option"
        >
          {{ label(option) }}
        </mat-option>
        <mat-option *ngIf="!filtered.length" disabled>{{
          noResultsText
        }}</mat-option>
      </ng-container>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
